<template>
    <v-container fluid style="height:calc(100vh - 80px); overflow: scroll">
        <v-dialog v-model="delDialog" persistent max-width="290">
            <v-card>
                <v-card-text>Are you sure you want to delete this officer?</v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn class="elc-button-radius" flat @click.native="delDialog = false">Cancel</v-btn>
                    <v-btn class="elc-button-radius-color" flat @click.native="deleteOfficer()">OK</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <div class="elc-card-club-count">
            <v-card>
                <v-card-title class="p-10">
                    <v-layout wrap>
                        <v-flex xs12 md8>
                            <span style="font-weight:500; font-size:22px; color: #596363">ELC Officers </span>
                        </v-flex>

                        <v-flex xs12 md3>
                            <v-text-field v-model="search" append-icon="search" label="Search"
                                          single-line
                                          hide-details></v-text-field>
                        </v-flex>
                        <v-flex xs12 md1 class="text-xs-right">
                            <div class="p-l-10 p-r-10">

                                <v-tooltip bottom>
                                    <v-btn fab slot="activator" class="elc-button-rounded"
                                           @click="redirectToAddNewOfficer">
                                        <v-icon dark>add</v-icon>
                                    </v-btn>
                                    <span>Add Officer</span>
                                </v-tooltip>

                            </div>
                        </v-flex>
                    </v-layout>
                </v-card-title>

                <!--<v-data-table :headers="headers" :items="officerFilter" :loading="loading"-->
                <v-data-table :headers="headers" :items="officerDetails" :loading="loading"
                              class="elc-deta-table fixed-header1" hide-actions :disable-initial-sort="true"
                              :no-data-text="loading?'':'No officers available'">

                    <template slot="items" slot-scope="props">
                        <td class="elc-capital" @click="openDetailDialog(props.item)"
                            style="cursor: pointer !important;">
                            {{props.item.name}}
                            <!--{{props.item.prefix}} {{props.item.fname}} {{props.item.mname}} {{props.item.lname}}-->
                        </td>

                        <td @click="openDetailDialog(props.item)" style="cursor: pointer !important;">
                            {{constant.rolePrefix_const[props.item.officer_role]}}
                        </td>

                        <td @click="openDetailDialog(props.item)" v-if="props.item.election_id!=null"
                            style="cursor: pointer !important;">
                            {{ props.item.election_id }}
                        </td>
                        <td v-else>-</td>
                        <td @click="openDetailDialog(props.item)" v-if="props.item.email!=null"
                            style="cursor: pointer !important;">
                            {{ props.item.email }}
                        </td>
                        <td v-else>-</td>
                        <td @click="openDetailDialog(props.item)" v-if="props.item.dob!=0"
                            style="cursor: pointer !important;">
                            {{ props.item.dob }}
                        </td>
                        <td v-else>-</td>
                        <td @click="openDetailDialog(props.item)" style="cursor: pointer !important;">
                            {{props.item.phone}}

                        </td>

                        <td @click="openDetailDialog(props.item)" style="cursor: pointer !important;">
                            {{ props.item.pincode }}

                        </td>

                        <td @click="openDetailDialog(props.item)" v-if="props.item.area!=null"
                            style="cursor: pointer !important;">
                            {{ props.item.area }}
                        </td>
                        <td v-else>-</td>
                        <td @click="openDetailDialog(props.item)" style="cursor: pointer !important;">
                            {{ props.item.district }}

                        </td>

                        <td style="cursor: pointer !important;">
                            <v-menu transition="slide-x-transition" bottom right>
                                <v-btn slot="activator" icon>
                                    <v-icon>more_horiz</v-icon>
                                </v-btn>

                                <v-list>
                                    <v-list-tile @click="openEditDialog(props.item)">
                                        <v-list-tile-title>
                                            Edit
                                        </v-list-tile-title>
                                    </v-list-tile>
                                    <v-list-tile @click="openDelDialog(props.item)">
                                        <v-list-tile-title>
                                            Delete
                                        </v-list-tile-title>
                                    </v-list-tile>
                                </v-list>

                            </v-menu>

                            <!-- <v-tooltip slot="activator" bottom>
                                 <v-icon class="p-t-10 p-r-10 p-b-10" slot="activator" small
                                         @click="openEditDialog(props.item)">edit
                                 </v-icon>
                                 <span>Edit</span>
                             </v-tooltip>
                             <v-tooltip slot="activator" bottom>
                                 <v-icon class="p-t-10 p-r-10 p-b-10" slot="activator" small
                                         @click="openDelDialog(props.item)">delete
                                 </v-icon>
                                 <span>Delete</span>
                             </v-tooltip>-->
                        </td>

                    </template>

                    <v-alert slot="no-results" :value="true" color="error" icon="warning">
                        Your search for "{{ search }}" found no results.
                    </v-alert>

                </v-data-table>
                <template v-if="totalCount > count">
                    <div class="text-xs-center pt-2" style="position: fixed;bottom: 50px;width: 96vw;">
                        <v-pagination color="#515a75" circle :length="totalPage" v-model="page" @input="pagination"
                                      :total-visible="7"></v-pagination>
                    </div>
                </template>


            </v-card>
        </div>

        <div v-if="addEditFlag">
            <add-officer :editObj="editOfficer" :officerDialog="addOfficerDialog" :addEditFlag="addEditFlag"
                         @closeOfficerDialog="cancelOfficerDialog"
                         @saveOfficer="saveOfficer" @updateOfficer="updateOfficer"></add-officer>
        </div>
        <div v-if="detailFlag">
            <officer-details-dialog :editObj="editOfficer" :officerDialog="addOfficerDialog"
                                    :detailShowFlag="detailFlag"
                                    @closeOfficerDialog="cancelOfficerDialog"
                                    @saveOfficer="saveOfficer" @updateOfficer="updateOfficer"></officer-details-dialog>
        </div>


        <div v-if="addFlag">
            <add-officer :officerDialog="addOfficerDialog" :addEditFlag="addEditFlag"
                         @closeOfficerDialog="cancelOfficerDialog"
                         @saveOfficer="saveOfficer" @updateOfficer="updateOfficer"></add-officer>
        </div>

        <alert-modal :alertMsg="msg" :alertMsgDialog="alertDialog" @closeAlert="alertDialog = false"></alert-modal>
    </v-container>
</template>

<script>
    import Common from '../Common/Constants'
    import AddOfficer from './AddOfficer'
    import OfficerDetailsDialog from './OfficerDetailsDialog'
    import AlertModal from '../Common/AlertModal'

    export default {
        name: "OfficerDetails",
        components: {AddOfficer, OfficerDetailsDialog, AlertModal},
        data() {
            return {
                constant: Common,
                loginOfficer: {},
                header: {},
                search: '',
                delDialog: false, delData: {},
                valid: false, msg: '',
                alertDialog: false,
                mask: "##### #####",
                headers: [
                    {text: 'Name', align: '', sortable: true, value: 'name'},
                    {text: 'Role', align: '', sortable: true, value: 'role'},
                    {text: 'Election ID', align: '', sortable: true, value: 'election_id'},
                    {text: 'Email', align: '', sortable: false, value: 'email'},
                    {text: 'D.O.B', align: '', sortable: false, value: 'dob'},
                    {text: 'Mobile', align: '', sortable: false, value: 'phone'},
                    {text: 'Pincode', align: '', sortable: false, value: 'pincode'},
                    {text: 'Area', align: '', sortable: true, value: 'area'},
                    {text: 'District', align: '', sortable: true, value: 'district'},
                    {text: 'Actions', sortable: false,},
                ],
                rolePrefix: [
                    {id: 0, value: 'Nodal Officer'},
                    {id: 1, value: 'AERO Officer'},
                    {id: 2, value: 'ERO Officer'},
                    {id: 3, value: 'DDRO Officer'},
                    {id: 4, value: 'DRO Officer'}
                ],
                officerDetails: [],
                loading: true,
                editedIndex: -1,
                dob: null, menu: false, officer: {dob: null},
                successToast: {
                    theme: "primary",
                    position: "top-right",
                    duration: 3000,
                    className: 'success-toast'
                },
                errorToast: {
                    theme: "primary",
                    position: "top-right",
                    duration: 3000,
                    className: 'error-toast'
                },
                addOfficerDialog: false, editOfficer: {},
                addEditFlag: false, addFlag: false, itemText: '',
                detailsDialog: false, detailFlag: false,
                searchVal: '',
                skip: 0, count: 25,
                totalCount: 0, totalPage: 0, page: 1,
            }
        },
        mounted() {
            this.getOfficerDetails()
        },
        created() {
            let self = this;
            let token = localStorage.getItem('token');
            self.loginOfficer = JSON.parse(localStorage.getItem('user'));
        },
        computed:
            {
                /*officerFilter: function () {
                    let self = this;
                    let result = self.officerDetails.filter(function (task) {
                        task.name = task.name === null ? '' : task.name;
                        task.role_name = task.role_name === null ? '' : task.role_name;
                        task.election_id = task.election_id === null ? '' : task.election_id;
                        task.email = task.email === null ? '' : task.email;
                        task.pincode = task.pincode === null ? '' : task.pincode;
                        task.area = task.area === null ? '' : task.area;
                        task.dob = (task.dob === null || task.dob === 0) ? '' : task.dob;
                        task.phone = task.phone === null ? '' : task.phone;
                        task.district = task.district === null ? '' : task.district;
                        return (task.name.toLowerCase().indexOf(self.search.toLowerCase()) >= 0 ||
                            task.role_name.toLowerCase().indexOf(self.search.toLowerCase()) >= 0 ||
                            task.election_id.toLowerCase().indexOf(self.search.toLowerCase()) >= 0 ||
                            task.email.toLowerCase().indexOf(self.search.toLowerCase()) >= 0 ||
                            task.pincode.toLowerCase().indexOf(self.search.toLowerCase()) >= 0 ||
                            task.area.toLowerCase().indexOf(self.search.toLowerCase()) >= 0 ||
                            task.dob.toLowerCase().indexOf(self.search.toLowerCase()) >= 0 ||
                            task.phone.toLowerCase().indexOf(self.search.toLowerCase()) >= 0 ||
                            task.district.toLowerCase().indexOf(self.search.toLowerCase()) >= 0)
                    });

                    return result

                }*/
            },
        watch: {
            search: function (val) {
                this.searchVal = val;
                this.getOfficerDetails()
            },
        },
        methods: {
            getOfficerDetails() {
                let self = this;
                let request = {
                    "filters": {
                        "search": self.searchVal,
                    },
                    "sort": "created_at",
                    "direction": "desc",
                    "skip": self.skip,
                    "count": self.count
                };
                if (self.search != '')
                    request.skip = 0;
                axios.post(Common.apiUrl + 'officer/getList', request)
                    .then(res => {
                        if (res.data.flag) {
                            res.data.data.officers.forEach(function (val) {
                                val.role_name = val.officer_role === null ? '' : self.constant.rolePrefix_const[val.officer_role];
                                val.name = (!val.prefix && !val.mname) ? val.fname + ' ' + val.lname
                                    : (val.prefix && !val.mname) ? val.prefix + ' ' + val.fname + ' ' + val.lname
                                        : (!val.prefix && val.mname) ? val.fname + ' ' + val.mname + ' ' + val.lname
                                            : val.prefix + ' ' + val.fname + ' ' + val.mname + ' ' + val.lname
                            });
                            self.officerDetails = res.data.data.officers;
                            self.totalCount = res.data.data.count;
                            self.totalPage = Math.ceil(self.totalCount / self.count);
                            self.loading = false;
                        }
                        else {
                            self.loading = false;
                            self.$toasted.show('Officer Not Found', self.errorToast)
                        }
                    })
                    .catch((handle) => {
                        self.$toasted.show(handle, self.errorToast);
                    })
            },
            pagination(str) {
                let self = this;
                self.skip = ((self.page - 1) * self.count);
                self.getOfficerDetails();

            },
            updateOfficer(officer) {
                let self = this;
                axios.post(Common.apiUrl + 'officer/update', officer)
                    .then(res => {
                        if (res.data.flag) {
                            self.$toasted.show('Officer Updated', self.successToast);
                            self.addEditFlag = false;
                            self.addOfficerDialog = false;
                            self.getOfficerDetails();
                        }
                        else {
                            self.alertDialog = true;
                            self.msg = '';
                            self.msg = res.data.message;
                        }
                    })
                    .catch((handle) => {
                        self.alertDialog = true;
                        self.msg = '';
                        self.msg = "Please fill valid details";
                    })
            },
            openDelDialog(data) {
                let self = this;
                self.delDialog = true;
                self.delData = {};
                self.delData = data;
            },
            deleteOfficer() {
                let self = this;
                let a = self.delData;
                const index = this.officerDetails.indexOf(a);
                let oid = this.officerDetails[index].officer_id;
                axios.get(Common.apiUrl + 'officer/delete/' + oid)
                    .then(function (res) {
                        if (res.data.flag) {
                            self.skip = self.officerDetails.length > 1 ? self.skip : self.skip - self.count;
                            self.getOfficerDetails();
                            self.$toasted.show('Officer Deleted', self.successToast);
                            // self.officerDetails.splice(index, 1);
                            self.$forceUpdate()
                        }
                        else {
                            self.$toasted.show(res.data.message, self.errorToast);
                        }
                    })
                    .catch((handle) => {
                        self.$toasted.show(handle, self.errorToast);
                    });
                self.delDialog = false
            },
            redirectToAddNewOfficer() {
                let self = this;
                self.addEditFlag = false;
                self.addFlag = true;
                self.addOfficerDialog = true
            },
            openEditDialog(data) {
                let self = this;
                self.editOfficer = data;
                self.addEditFlag = true;
                self.addOfficerDialog = true;
            },
            openDetailDialog(data) {
                let self = this;
                self.editOfficer = data;
                self.detailFlag = true;
                self.addOfficerDialog = true;
            },
            saveOfficer() {
                this.getOfficerDetails();
                this.addOfficerDialog = false;
            },
            cancelOfficerDialog() {
                let self = this;
                self.addEditFlag = false;
                self.detailFlag = false;
                self.addFlag = false;
                self.addOfficerDialog = false;
            },

        },

    }
</script>

<style>

</style>




// WEBPACK FOOTER //
// src/components/Officer/OfficerDetails.vue